import Vue from "vue";
class QuestionService {

  Get(id) {
    return Vue.prototype.$http({
      url: "question/get/" + id,
      method: "GET"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "question/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  GetGrid(page) {
    return Vue.prototype.$http({
      url: "/question/get-grid/" + page + "/20",
      method: "GET"
    });
  }

  GetAll() {
    return Vue.prototype.$http({
      url: "/question/get-all/",
      method: "GET"
    });
  }
}

export default new QuestionService();
